module.exports = __webpack_public_path__ + "img/line-red.76429609.svg";